var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":15,"dense":"","height":"241px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }